import { clsx } from 'clsx';
import * as React from 'react';

import * as styles from './styles.css';

interface IHeaderLayoutProps extends React.PropsWithChildren {
  noResize?: boolean;
  content: React.ReactNode;
  navbar: React.ReactNode;
  isNeedDivider: boolean;
}

export const HeaderLayout: React.FC<IHeaderLayoutProps> = ({ noResize, content, navbar, isNeedDivider, children }) => {
  return (
    <div className={clsx(styles['wrapper'], noResize && styles['static'], isNeedDivider && styles['divider'])}>
      <div className={styles['inner']}>{content}</div>
      <div className={styles['inner']}>{navbar}</div>

      {children}
    </div>
  );
};
